import * as yup from "yup";

export const newPasswordValidationSchema = yup.object().shape({
    password: yup
        .string()
        .min(8, 'Deve essere di almeno 8 caratteri')
        .matches(/[a-z]/, "Deve contenere almeno un carattere minuscolo")
        .matches(/[A-Z]/, "Deve contenere almeno un carattere maiuscolo")
        .matches(/[\d]/, "Deve contenere almeno un carattere numerico")
        .required('Campo obbligatorio'),
    passwordConfirmation: yup.string()
        .oneOf([yup.ref('password')], 'Deve essere uguale a password')
        .required('Campo obbligatorio'),
});